import { useState } from 'react';
import { mediaUrl } from '../../../utils/mediaUrl';
import { ProductTags } from '../../ui/ProductTags';
import styles from './ProductGallery.module.css';

export function ProductGallery({ images = [], tags = [], alt = 'Фото товара' }) {
  const sorted = [...images].sort((a, b) => a.sort_order - b.sort_order);
  const [activeIndex, setActiveIndex] = useState(0);

  if (sorted.length === 0) {
    return (
      <div className={styles.main}>
        {tags.length > 0 && (
          <ProductTags tags={tags} size="lg" className={styles.tags} />
        )}
        <div className={styles.placeholder}>Нет фото</div>
      </div>
    );
  }

  const active = sorted[activeIndex];

  return (
    <div className={styles.gallery}>
      {sorted.length > 1 && (
        <div className={styles.thumbs}>
          {sorted.map((img, index) => (
            <button
              key={img.id}
              type="button"
              className={`${styles.thumb} ${index === activeIndex ? styles.thumbActive : ''}`}
              onClick={() => setActiveIndex(index)}
            >
              <img src={mediaUrl(img.url)} alt="" />
            </button>
          ))}
        </div>
      )}

      <div className={styles.main}>
        {tags.length > 0 && (
          <ProductTags tags={tags} size="lg" className={styles.tags} />
        )}
        <img
          src={mediaUrl(active.url)}
          alt={alt}
          className={styles.mainImage}
        />
      </div>
    </div>
  );
}
